import { render, staticRenderFns } from "./EditReportRecipient.vue?vue&type=template&id=546e38de&"
import script from "./EditReportRecipient.vue?vue&type=script&lang=js&"
export * from "./EditReportRecipient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports